import  gql  from 'graphql-tag'

export const REGIONAL_DIRECTOR = gql`mutation regionalDirector($input: RegionalDirectorMutationInput!){
    regionalDirector(input: $input){
        errors{
            field
            messages
        }
        regionalDirector{
            user{
                id
                name
                surname
                username
                email
                authSystem
                isActive
                group{
                    id
                    name
                }
            }
            regional{
                id
                name
            }
        }
    }
}`;